import api from '@/utils/api'

export default {
    // params: { from, to (ISO, to exclusive), groupBy: day|week|month, seasonId, leagueId, competition: league|cup, phase }
    getDashboard(params) {
        const query = Object.keys(params)
            .filter(key => params[key] !== null && params[key] !== undefined && params[key] !== '')
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&')
        return api.get(`dashboard?${query}`)
    }
}
